import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, serchSelectManage, tabulation } from "@/mixins/index";
import { productList, delProduct } from "@/api/management/productMapping";
import addproductMapping from "./components/productMapping";
import { listNo } from "@/api/advRelation";
import { getPlatform } from "@/api/serchSelect";
import { mapState } from "vuex";
export default {
  name: "productMapping",
  mixins: [serchSelect, serchSelectManage, tabulation],
  components: {
    addproductMapping: addproductMapping
  },
  data: function data() {
    return {
      total: 0,
      tableData: [],
      InitializeOrNot: false
    };
  },
  created: function created() {},
  activated: function activated() {
    this.searchClick();
  },
  computed: _objectSpread({}, mapState("d2admin", {
    searchgames: function searchgames(state) {
      return state.serchSelect.gameAll;
    }
  })),
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      listNo(this.searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.length && e > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform', 'channel', 'pkg'];
            _this.tableData = res.data.length ? _this.$utils.dataConversion(res.data, list) : [];
            console.log("this.tableData", _this.tableData);

            _this.$nextTick(function () {
              _this.getTableRight();
            });
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      var _this2 = this;

      if (!text) {
        return;
      }

      this.$copyText(text).then(function (e) {
        _this2.$Message.success(_this2.$t('copySuccess'));
      }, function (e) {
        this.$Message.success(this.$t('copyFailed'));
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(function () {
        delProduct({
          id: id
        }).then(function (res) {
          if (res.status == 200) {
            _this3.$message({
              type: 'success',
              message: _this3.$t('deleteSuccessExclamation')
            });

            _this3.$store.dispatch('d2admin/serchSelect/getAllGame');

            _this3.$store.dispatch('d2admin/serchSelect/getAllProduct');

            _this3.searchClick(_this3.searchData.page);
          }
        });
      });
    },
    gamechangeManageN: function gamechangeManageN(game_mark) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.searchData.platform = "";
        _this4.searchData.channel = "";
        _this4.searchData.pkg = "";
        _this4.searchplatforms = [];
        _this4.searchchannels = [];
        _this4.searchpkgs = [];
        var game_id = [];
        game_mark.map(function (item) {
          game_id.push(_this4.searchgames.find(function (a) {
            return a.game_mark == item;
          }).game_id);
        });
        game_id = game_id.toString();

        if (game_mark.length) {
          getPlatform({
            game_id: game_id
          }).then(function (res) {
            _this4.searchplatforms = res.data;
            resolve();
          });
        }
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }].concat(_toConsumableArray(this.sericeArr));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    } // handleCurrentChange(val) {},

  }
};